import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {loadSalutationsStart} from '../../store/actions/anrede.actions';
import {select, Store} from '@ngrx/store';
import {State} from '../../store/reducer/mitarbeiterverwaltung.reducer';
import {Observable} from 'rxjs';
import {AnredeItem} from '../../anrede.model';
import {RolleItem} from '../../rolle.model';
import {addMitarbeiterStart} from '../../store/actions/mitarbeiter-add.actions';
import {editMitarbeiterStart} from '../../store/actions/mitarbeiter-edit.actions';
import * as moment from 'moment';
import {MatSelect, MatSelectChange} from '@angular/material/select';
import {loadRollenStart} from "../../store/actions/rolle.actions";
import {InformationFormComponent} from "../../../../ui-components/information-form/information-form.component";
import {HttpClient} from "@angular/common/http";
import {SpesenartItem} from '@src/app/pages/Zeiterfassung/spesenart.model';
import {Zeitstate} from '@src/app/pages/Zeiterfassung/store/reducer/zeiterfassung.reducer';
import {loadSaldoStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getSaldo.actions';
import {SaldoItem} from '@src/app/pages/Mitarbeiterverwaltung/saldo.model';
import {SpesenFormdialogComponent} from '@src/app/pages/Zeiterfassung/components/spesen-form-dialog/spesen-formdialog.component';
import {UserinfoFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/userinfo-form-dialog/userinfo-formdialog.component';
import {loadUserInfoStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getUserInfo.actions';
import {UserInfoItem} from '@src/app/pages/Mitarbeiterverwaltung/userInfo.model';

export interface DialogData{
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
  id: number;
  vorname: string;
  name: string;
  anrede: string;
  geburtstag: string;
  email: string;
  passwort: string;
  mobile: string;
  rolle: string;
  ferientage: number;
  anstellungprozent: number;
  ort: string;
  plz: string;
  str1: string;
  str2: string;
  stundenProTag: number;
  aktiv: number;
}

@Component({
  selector: 'app-mitarbeiter-formdialog',
  templateUrl: './mitarbeiter-formdialog.component.html',
  styleUrls: ['./mitarbeiter-formdialog.component.scss']
})

export class MitarbeiterFormdialogComponent implements OnInit {

  constructor(
    private http: HttpClient,
    public dialogRef: MatDialogRef<MitarbeiterFormdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public zeitStore: Store<{ zeiterfassung: Zeitstate }>,
    private store: Store<{ mitarbeiterverwaltung: State }>)

  {
    dialogRef.disableClose = true;
    this.$userInfos = store.pipe(select((state) => state.mitarbeiterverwaltung.userinfos));
    this.$anreden = store.pipe(select((state) => state.mitarbeiterverwaltung.anreden.items));
    this.$rollen = store.pipe(select((state) => state.mitarbeiterverwaltung.rollen.items));
    this.$spesenarten = zeitStore.pipe(select((state) => state.zeiterfassung.spesenarten));
    this.$userInfos = store.pipe(select((state) => state.mitarbeiterverwaltung.userinfos));
    // tslint:disable-next-line:triple-equals
    if (data.geburtstag == ''){
      this.geburtstag = null;
    }
    else{
      this.geburtstag = moment(data.geburtstag).format('YYYY-MM-DD');
    }
    this.mitarbeiterForm.patchValue({
        id: data.id,
        name: data.name,
        vorname: data.vorname,
        email: data.email,
        passwort: data.passwort,
        geburtstag: this.geburtstag,
        mobile: data.mobile,
        rolle: data.rolle,
        ferientage: data.ferientage?.toFixed(1),
        anstellungprozent: data.anstellungprozent,
        anrede: data.anrede,
        ort: data.ort,
        plz: data.plz,
        str1: data.str1,
        str2: data.str2,
        stundenProTag: data.stundenProTag,
        aktiv: data.aktiv,
    });
  }
  public wertDatum = new Date().toLocaleDateString();
  public parseDateString = this.wertDatum;
  public parsedDatum = new Date(this.parseDateString);
  public $anreden: Observable<AnredeItem[]>;
  public $spesenarten: Observable<SpesenartItem[]>;
  public $rollen: Observable<RolleItem[]>;
  public $saldos: Observable<SaldoItem[]>;
  public $userInfos: Observable<UserInfoItem[]>;
  public vergleichVariable: string;
  public geburtstag;
  @ViewChild('mySel') private skillSel: MatSelect;
  // tslint:disable-next-line:variable-name
  public last_selection = null;

  public mitarbeiterForm = new FormGroup({
    anrede: new FormControl(''),
    name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(255), Validators.pattern('[a-zA-Z áéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ]*')]),
    // tslint:disable-next-line:max-line-length
    vorname: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(255), Validators.pattern('[a-zA-Z áéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ]*')]),
    // tslint:disable-next-line:max-line-length
    email: new FormControl({value: '', disabled: this.data.email}, [Validators.required, Validators.minLength(3), Validators.maxLength(255), Validators.pattern('^[a-záéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ0-9._%+-]+@[a-záéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ0-9.-]+\\.[a-z]{2,4}$')], ),
    passwort: new FormControl('', [ Validators.maxLength(255)]),
    geburtstag: new FormControl('', [Validators.maxLength(255)]),
    mobile: new FormControl('', [Validators.maxLength(255), Validators.pattern('^[0-9]*$')]),
    rolle: new FormControl('', [Validators.required]),
    ort: new FormControl('', [Validators.maxLength(255), Validators.pattern('[a-zA-Z áéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ]*')]),
    plz: new FormControl('', [Validators.min(1000), Validators.maxLength(255), Validators.pattern('^[0-9]*$')   ]),
    str1: new FormControl('', [Validators.maxLength(255)]),
    str2: new FormControl('', [Validators.maxLength(255)]),
    aktiv: new FormControl({value: '', disabled: this.data.rolle === 'Admin'}),
    id: new FormControl(''),
    });

  public yearForm = new FormGroup({
    year: new FormControl('')
  });

  /* Wandelt Datum um: Ohne Zeitzone und im richtigen Backendformat */
  public wandler(datum: any): any {
    // tslint:disable-next-line:triple-equals
    if (datum == undefined){
      return null;
    }
    const dwD = datum.toLocaleString( 'en-US', {timezone: 'utc'} );
    const backendDat = moment(dwD).format('YYYY-MM-DD');
    return backendDat;
  }

  public getErrorMessage(formField: string): string {
    const formControl = this.mitarbeiterForm.get(formField);
    if ( formControl.hasError('required')){
      return `pages.mitarbeiterverwaltung.mitarbeiterDialog.err.${formField}.pflichtfeld`;
    }
    else if ( formControl.hasError('minlength')){
      return `pages.mitarbeiterverwaltung.mitarbeiterDialog.err.${formField}.minlength`;
    }
    else if ( formControl.hasError('maxlength')){
      return `pages.mitarbeiterverwaltung.mitarbeiterDialog.err.${formField}.maxlength`;
    }
    else if ( formControl.hasError('min')){
      return `pages.mitarbeiterverwaltung.mitarbeiterDialog.err.${formField}.min`;
    }
    else if ( formControl.hasError('pattern')){
      return `pages.mitarbeiterverwaltung.mitarbeiterDialog.err.${formField}.pattern`;
    }
    else if ( formControl.hasError('max')){
      return `pages.mitarbeiterverwaltung.mitarbeiterDialog.err.${formField}.max`;
    }
    return 'pages.mitarbeiterverwaltung.mitarbeiterDialog.err.generic';
  }

  public handleSubmitClick(): void{
    this.mitarbeiterForm.value.geburtstag = this.wandler(this.mitarbeiterForm.value.geburtstag);
    const item = this.mitarbeiterForm.getRawValue();

    if (this.data.id) {
      this.store.dispatch(editMitarbeiterStart({item}));
    } else {

      // Check ob User EMAIL schon gebraucht wird
      this.http.get
      (
        window.location.protocol + '//' + window.location.hostname + `/myDay/backend/checkIfActiveUserExists.php?email=${item.email}`,
        {responseType: 'json'}
      ).subscribe((data: {data: {aktiv: number}}) => {
        // ERROR: USER EXISTIERT BEREITS
        if (data.data.aktiv == 0 || data.data.aktiv == 1){
          const okDialog = this.dialog.open(InformationFormComponent, {
            data: {
              title: 'Information',
              text: 'pages.mitarbeiterverwaltung.mitarbeiterDialog.error'
            }
          });
        }
        // User hinzufügen
        else{
          this.store.dispatch(addMitarbeiterStart({item}));
        }
      });
    }
    this.dialogRef.close(true);
  }

  public handleCancelClick(): void{
    this.dialogRef.close(true);
  }

  public addUserinfo(): void{
    this.dialog.open(UserinfoFormdialogComponent, {
      maxWidth: '90%',
      data: {
        title: 'pages.mitarbeiterverwaltung.userinfo.htitle',
        submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
        cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
        userId: this.mitarbeiterForm.value.id
      },
    });
  }

  public filterUserInfo(): void{
    this.store.dispatch(loadUserInfoStart({userId: this.data.id, showYears: this.yearForm.controls.year.value ? 1 : 0}));
  }


  ngOnInit(): void {
    this.store.dispatch(loadUserInfoStart({userId: this.data.id, showYears: 0}));
   // this.store.dispatch(loadSaldoStart({userId: this.data.id}));
    this.store.dispatch(loadSalutationsStart());
    this.store.dispatch(loadRollenStart());
  }

  public okClicked(): void {
    this.last_selection = this.mitarbeiterForm.controls.rolle.value;
    this.skillSel.close();
  }

}
